export var ADVANCE_DECLINE_VIEW_ALL = "ADVANCE_DECLINE_VIEW_ALL";
export var ADVANCE_DECLINE_VIEW_ALL_STREAM = "ADVANCE_DECLINE_VIEW_ALL_STREAM";
export var ADVANCE_DECLINE_VIEW_ALL_QUOTE_STREAM = "ADVANCE_DECLINE_VIEW_ALL_QUOTE_STREAM";
export var ADVANCE_DECLINE_VIEW_ALL_ERROR = "ADVANCE_DECLINE_VIEW_ALL_ERROR";
export var ADVANCE_DECLINE_VIEW_ALL_HIDE_ERROR = "ADVANCE_DECLINE_VIEW_ALL_HIDE_ERROR";
export var ADVANCE_DECLINE_VIEW_ALL_START_LOADER = "ADVANCE_DECLINE_VIEW_ALL_START_LOADER";
export var ADVANCE_DECLINE_VIEW_ALL_STOP_LOADER = "ADVANCE_DECLINE_VIEW_ALL_STOP_LOADER";
